import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { keys, zip, map, zipObj } from 'ramda';

import { Table } from '@app/models/tables.model';

@Component({
    selector: 'nh-checkbox-list',
    templateUrl: './checkbox-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxListComponent implements OnInit {
  @Input() checkboxGroup: FormGroup;
  @Input() referenceTable: Table;
  @Input() label = null;
  @Input() inline = false;
  @Input() disabled = false;
  @Input() readonlyControls: string[] = [];
  @Input() uniqueString: string;
  @Input() ariaRequired: boolean = false;
  @Input() globalLangTranslate: boolean = true;
  @Input() fromCheckboxList: boolean = false;
  // @Input() checkboxName: string;

  checkboxList: any[];

  ngOnInit() {
    const createCheckboxes = map(zipObj(['control', 'reference']));
    const zipControls = zip(keys(this.checkboxGroup.controls), this.referenceTable);
    const baseList = createCheckboxes(zipControls);
    this.checkboxList = baseList.map((item: any) => ({
      ...item,
      readonly: this.readonlyControls.includes(item.control)
    }));
  }
}